import React from "react"
import posed, { PoseGroup } from "react-pose"

import { useOvermind } from "../overmind"

export function Submenu({ item, index, subitem }) {
  const { state, actions } = useOvermind()

  const MenuRoot = posed.div({
    close: { opacity: 0, transition: { ease: "linear", duration: 600 } },
    opening: {
      opacity: 1,
      transition: { ease: "linear", duration: 600 },
      delayChildren: 400,
      staggerChildren: 50
    },
    initialPose: "close"
  })

  const MenuElement = posed.div({
    // preEnter: {
    //   y: 75,
    //   opacity: 0
    // },
    close: { y: 75, opacity: 0, transition: { duration: 0 } },
    opening: { y: 0, opacity: 1, transition: { duration: 400 } }
  })

  const MenuSubElement = posed.div({
    close: { y: 55, opacity: 0, transition: { duration: 0 } },
    opening: { y: 0, opacity: 1, transition: { duration: 400 } }
  })
  return (
    <MenuRoot pose={state.menu.activeFirstElement ? "opening" : "close"} initialPose={"close"} className="menuColumns">
      {/* <PoseGroup animateOnMount preEnterPose="preEnter"> */}
      {state.menu.activeFirstElement &&
        state.menu.data[state.menu.activeFirstElement].items.map((item, index) => {
          if (!item.hasOwnProperty("items")) {
            return (
              <MenuElement key={item.id_md5} className="menuSubmenuElement">
                <a href={item.link}>{item.text}</a>

                <p>{item.subtitle}</p>
              </MenuElement>
            )
          } else {
            return (
              <MenuElement key={item.id_md5} className="menuSubmenuElement menuSubmenuElementPadding">
                <h2>{item.text}</h2>
                <PoseGroup>
                  {item.items.map((subitem, index) => {
                    console.log(subitem)
                    return (
                      <MenuSubElement key={subitem.id_md5} className="menuAdditionallyElement">
                        <a href={subitem.link}>{subitem.text}</a>
                      </MenuSubElement>
                    )
                  })}
                </PoseGroup>
              </MenuElement>
            )
          }
        })}
      {/* </PoseGroup> */}
    </MenuRoot>
  )
}
